<template>
  <div>
    <router-view />
  </div>
</template>

<style>
  html,
  body {
    height: 100%;
    -webkit-text-size-adjust:none;
    text-size-adjust: none;
    /* font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, PingFang SC, Microsoft YaHei, Source Han Sans SC, Noto Sans CJK SC, WenQuanYi Micro Hei, sans-serif */
  }
  html,
  body,
  div,
  span,
  img {
    margin: 0;
    padding: 0;
  }

  .cf {
    color: #fff;
  }

  .c4c {
    color: #4c4c4c;
  }

  .cf80 {
    color: #808080;
  }
  .fs9{
    font-size: 9px !important;
  }
  .fs10{
    font-size: 10px !important;
  }
  .fs11{
    font-size: 11px !important;
  }

  .fs12 {
    font-size: 12px !important;
  }

  .fs13 {
    font-size: 13px !important;
  }

  .fs14 {
    font-size: 14px !important;
  }

  .fs15 {
    font-size: 15px !important;
  }

  .fs16 {
    font-size: 16px !important;
  }

  .fs18 {
    font-size: 18px !important;
  }



  .flex {
    display: flex;
  }

  .space-between {
    justify-content: space-between;
  }

  .align-center {
    align-items: center;
  }

  .fw3 {
    font-weight: 300;
  }

  .fwb {
    font-weight: bold;
  }

  .pd5 {
    padding: 5px 0px;
  }

  .pd3 {
    padding: 3px 0px;
  }


  .vs-line {
    width: 100%;
    height: 16px;
  }

  .vs-line-l {
    background-color: #000;
    width: 30%;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    text-align: center;
    font-size: 12px;
    line-height: 16px;
    color: #fff;
  }

  .vs-line-r {
    background-color: #fff;
    width: 70%;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
    text-align: center;
    font-size: 12px;
    line-height: 16px;
    color: #000;
  }

  .vs-line-r100 {
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
  }

  .vs-line-l100 {
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
  }


  .border-all {
    border: solid 1px rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    box-sizing: border-box;
  }

  .bgwhite {
    background-color: rgba(255, 255, 255) !important;
  }

  .isWh {
    background-color: #354ec9;
  }

  .isNWh {
    background-color: #c93587;
  }

  .stoneLine {
    height: 1px;
    line-height: 1px;
    padding-left: 1px;
    position: relative;
    font-size: 20px;
  }

  .stoneLine:after {
    content: "";
    display: block;
    position: absolute;
    left: -50%;
    width: 200%;
    height: 1px;
    background: #707277;
    transform: scale(0.5);
    -webkit-transform: scale(0.5);
  }


  .stoneLine1 {
    width: 100%;
    margin: 0 auto;
    position: relative;
  }

  .stoneLine1:after {
    content: " ";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
    background: red;
    transform: scaleY(0.5);
  }

*{ 
 -webkit-touch-callout:none; /*系统默认菜单被禁用*/
 -webkit-user-select:none; /*webkit浏览器*/
 -khtml-user-select:none; /*早期浏览器*/
 -moz-user-select:none;/*火狐*/
 -ms-user-select:none; /*IE10*/
 user-select:none; 
} 
input{ 
  user-select: none;
 -webkit-user-select:auto; /*webkit浏览器*/ 
}
textarea{
  user-select: none;
 -webkit-user-select:auto; /*webkit浏览器*/
}

</style>